import React from "react";
import Chart from "react-apexcharts";
import useLastThreeDaysRevenue from "../hooks/useLastThreeDaysRevenue";

const LastThreeDaysRevenueChart = () => {
  const { data, isLoading, error } = useLastThreeDaysRevenue();

  const categories = ["Day Before Yesterday", "Yesterday", "Today"];
  const series = [
    {
      name: "Revenue (GBP)",
      data: data?.data
        ? [
            data.data.day_before_yesterday || 0,
            data.data.yesterday || 0,
            data.data.today || 0,
          ]
        : [0, 0, 0],
    },
  ];

  const options = {
    chart: { type: "bar", height: 350 },
    plotOptions: { bar: { borderRadius: 4, horizontal: false } },
    dataLabels: { enabled: false },
    xaxis: { categories },
    yaxis: {
      labels: { formatter: (val) => `£${val.toFixed(2)}` },
    },
    colors: ["#1E90FF"],
    tooltip: { y: { formatter: (val) => `£${val.toFixed(2)}` } },
  };

if (isLoading)
  return (
    <div className="top-loader">
      <div className="top-loader-bar"></div>
    </div>
  );

  if (error) return <div>Failed to load daily revenue</div>;

  return (
    <div className="card" style={{ borderRadius: "15px", padding: "20px" }}>
      <h4>Revenue (Last 3 Days)</h4>
      <Chart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default LastThreeDaysRevenueChart;
